import React from 'react';
import { string } from 'prop-types';

import styles from './Easing.css';

const Easing = ({ func }) => (
  <div className={styles.easeContainer}>
    <div className={styles.radio} style={{ animationTimingFunction: func }} />
  </div>
);

Easing.propTypes = {
  func: string
};

export default Easing;


// WEBPACK FOOTER //
// ./src/containers/foundations/Motion/Easing/Easing.js